var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-tab',{attrs:{"id":"tab-chat","md-label":"Chat"}},[_c('rocket-chat')],1)}
var staticRenderFns = []

export { render, staticRenderFns }